module.exports = __webpack_public_path__ + "img/mobile.8ff3a5b3.svg";